
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignupPage from './pages/SignupPage';
import SignupPageAuth from './pages/SignupPageAuth';
import LoginPage from './pages/LoginPage';
import SubscriptionPage from './pages/SubscriptionPage';
import PaymentConfirmationPage from './pages/PaymentConfirmationPage';
import bgImage from './assets/freshfold-bg.png';
import AccountPage from './pages/AccountPage';

export default function App() {
  return (
    <div style={{ minHeight: '100vh' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignupPage />} />
          <Route path="/signup" element={<SignupPageAuth />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/confirmation" element={<PaymentConfirmationPage />} />
          <Route path="/account" element={<AccountPage />} />
          {/* Only allow /subscribe via dropdown menu */}
          <Route path="/subscribe" element={<SubscriptionPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
